<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/96TqWJ/tc-custom/9780226109954.jpg?1732166256176" alt="This image is the cover for the book Fermi Remembered"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fermi Remembered
      </h1>
      <p class="bookDescription body article font2">
        <p>Nobel laureate and scientific luminary Enrico Fermi (1901-54) was a pioneering nuclear physicist whose contributions to the field were numerous, profound, and lasting. Best known for his involvement with the Manhattan Project and his work at Los Alamos that led to the first self-sustained nuclear reaction and ultimately to the production of electric power and plutonium for atomic weapons, Fermi's legacy continues to color the character of the sciences at the University of Chicago. During his tenure as professor of physics at the Institute for Nuclear Studies, Fermi attracted an extraordinary scientific faculty and many talented students—ten Nobel Prizes were awarded to faculty or students under his tutelage.<br/><br/> Born out of a symposium held to commemorate the hundredth anniversary of Fermi's birth, <i>Fermi Remembered</i> combines essays and newly commissioned reminiscences with private material from Fermi's research notebooks, correspondence, speech outlines, and teaching to document the profound and enduring significance of Fermi's life and labors. The volume also features extensives archival material—including correspondence between Fermi and biophysicist Leo Szilard and a letter from Harry Truman—with new introductions that provide context for both the history of physics and the academic tradition at the University of Chicago.<br/><br/> Edited by James W. Cronin, a University of Chicago physicist and Nobel laureate himself, <i>Fermi Remembered</i> is a tender tribute to one of the greatest scientists of the twentieth century.<br/><br/> Contributors:<br/> Harold Agnew<br/> Nina Byers<br/> Owen Chamberlain<br/> Geoffrey F. Chew<br/> James W. Cronin<br/> George W. Farwell<br/> Jerome I. Friedman<br/> Richard L. Garwin<br/> Murray Gell-Mann<br/> Maurice Glicksman<br/> Marvin L. Goldberger<br/> Uri Haber-Schaim<br/> Roger Hildebrand<br/> Tsung Dao Lee<br/> Darragh Nagle<br/> Jay Orear<br/> Marshall N. Rosenbluth<br/> Arthur Rosenfeld<br/> Robert Schluter<br/> Jack Steinberger<br/> Valentine Telegdi<br/> Al Wattenberg<br/> Frank Wilczek<br/> Lincoln Wolfenstein<br/> Courtenay Wright<br/> Chen Ning Yang<br/> Gaurang Yodh</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James W. Cronin
      </h2>
      
      <p class="authorDescription body article"><B>James W. Cronin</B> is University Professor Emeritus in the Department of Astronomy and Astrophysics at the University of Chicago.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?544c1405